<template>
    <div class="index-box">
        <div class="index-title">加群加粉活码</div>

        <el-form :model="ruleForm" status-icon :rules="rules" ref="urlForm" label-width="100px">
            <el-form-item label="活码名称：" prop="url">
                <el-input v-model="ruleForm.huomaname" clearable @clear="urlClear" @input="urlInput"></el-input>

            </el-form-item>
          <div style="padding:20px 0;">
            <div class="mb-10" style="text-align: left; position: relative;">
              选择专属域名：
              <el-select v-model="exc_domain_id" clearable placeholder="请选择" :loading="isLoading" @visible-change="getDomainList">
                <el-option v-for="item in options" :key="item.id" :label="item.domain" :value="item.id"></el-option>
              </el-select>
              <router-link to="/tabs/buyDomain" style="font-size: 12px;background:#f0f9f3;color:#037d2b;padding:6px 10px;margin-left: 20px;font-weight: bold;"> &nbsp;
                <em class="iconfont icon-dwzRectangleCopy23"></em> 提示：专人专用-域名首页直接展示，点击购买
              </router-link>


            </div>
          </div>
<!--          <div class="chioce-huoma-mode d-flex align-items-center ">-->
<!--            <label for="group-huoma">-->
<!--              <div class="chioce-huoma-list d-flex align-items-center cursor-pointer" >-->
<!--                <input id="group-huoma" v-model="ruleForm.huomaMode" name="huomaMode" value="0" type="radio" checked="" style="display: inline-block">-->
<!--                <i class="checked" style="display: inline-block"></i>-->
<!--                <span >加粉加群活码</span>-->
<!--              </div>-->
<!--            </label>-->
<!--            <label for="groug-powderhuoma">-->
<!--              <div class="chioce-huoma-list ml-30 d-flex align-items-center cursor-pointer">-->
<!--                <input id="groug-powderhuoma" v-model="ruleForm.huomaMode" name="huomaMode" value="1" type="radio">-->
<!--                <i style="display: inline-block"></i>-->
<!--                <span>分组群活码</span>-->
<!--              </div>-->
<!--            </label>-->
<!--            <div class="tips-groug-wen" v-on:mouseover="changeActive(tips-groug-wen-info)" v-on:mouseout="removeActive(tips-groug-wen-info)">-->
<!--              <img src="//static.3wt.cn/static/3wt.cn/images/wen.png" alt="">-->
<!--              <div class="tips-groug-wen-info">-->
<!--                <p>什么是分组群活码</p>-->
<!--                <span>-->
<!--                                        分组群活码可以实现对用户的分类管理，不同类型的用户进不同的群，比如：自定义分组让用户自己选择进入小学群、初中群或者高中群。-->
<!--                                    </span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <input type="radio" name="radios" value="2" v-model="param"><label>分组群活码</label>-->
            <div style="width: 250px;margin: 60px 37%">
                <el-button class="btn-box"  type="primary" @click="submitForm">立刻创建</el-button>
            </div>
        </el-form>
        <div class="introduce-card position-relative">
          <div class="position-absolute icon-support">
            <p>- 支持 -</p>
            <div class="d-flex justify-content-between">
              <img  src="../../assets/res/images/icon-support1.png" alt="">
              <img style="margin-left: 10px"  src="../../assets/res/images/icon-support2.png" alt="">
              <img style="margin-left: 10px"  src="../../assets/res/images/icon-support3.png" alt="">
            </div>
          </div>
          <p>活码功能介绍</p>
          <!-- <span>群活码可解决在大量用户加群时，需频繁更换群码（微信群码、QQ群码）的问题，并能实时监控加群人数，及时调整加群策略。</span> -->
          <span>1) 活码功能可解决在使用二维码（微信/QQ/钉钉个人码，微信/QQ/钉钉群码）批量添加好友或批量邀请入群时，人满后需频繁更换二维码的情况。<br>
                              本功能可将您的多个二维码合为一个二维码，并根据实时加入人数自动进行切换，提高您的推广效率 <br>

                          </span>
          <span>2) 如果绑定专属域名，就可作为您的官方网站 <br>
                       可以上传一张介绍长图，即通过主域名（比如:http://6st.cn/）就可打开你的内容，神奇吧！需要购买一个专属域名，然后跳转地址填写生成的短链接<br>

                          </span>
<br>
          <br>


          <p>注意事项</p>
          <span>禁止上传违法违规内容，禁止将本功能用于违法、违规用途，一经发现立即停用活动并封停账号</span>
        </div>
    </div>

</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "LiveCode",
        data() {
            const validateUrl = (rule, value, callback) => {

                console.log(value)
                if (value === '') {
                    callback(new Error('请输入活码名称'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    huomaname: '',
                    huomaMode: 0,
                },
                rules: {
                    url: [
                        { validator: validateUrl, trigger: 'blur' }
                    ],
                },
                exc_domain_id:'',
              isLoading:false,
              options:[],
                shortId: 0,
                shortUrl: "123456789",
                isShowResult: false,
                param:'1'
            }
        },
        mounted() {
        },
        methods: {
            submitForm() {
                this.$refs.urlForm.validate((valid) => {
                    if (valid) {
                        this.zh();
                    }
                });
            },
          async getDomainList(val) {
            if (!val) return;
            if (this.isLoad) return;
            const {ret,data} = await this.$api.exclusive.getUserList();
            if (ret === 1000){
              this.isLoad = true;
              this.isLoading = false;
              this.options = data.list;
            }
          },
            async zh() {
                const postData = {
                    huomaMode: this.ruleForm.huomaname,
                    live_code_type: this.ruleForm.huomaMode,
                     ext_domain_id:this.exc_domain_id
                };
                const {ret,data} = await this.$api.index.addHuoMa(postData);
                if (ret === 1000){
                    this.$message.success("转换成功");
                    await this.$router.push('/tabs/MyliveCode/' + data.id);
                    // this.shortId = data.id;
                    // this.shortUrl = data.huomaname;
                    // this.bindQRCode();
                }
            },
            urlClear() {
                this.shortId = "";
                this.shortUrl = "";
            },
            urlInput(val) {
                if (val === ''){
                    this.shortId = "";
                    this.shortUrl = "";
                }
            },
            batchConversion() {
                this.$router.push('/tabs/batchConversion');
            },
            savePic() {
                let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
                let a = document.createElement('a');
                a.href = myQrCode[0].toDataURL('image/png');
                a.download = this.shortUrl;
                a.click();
            },
            changeActive(){
              $('.tips-groug-wen-info').css("display",'block');
            },
            removeActive(){
              $('.tips-groug-wen-info').css("display",'none');
            }
        },
    }
</script>

<style scoped>
    .index-box{
        width: 940px;
        height: auto;
        margin-left: 80px;
        padding: 30px 120px 30px 40px;
    }
    .index-box .index-title{
        width: 100%;
        height: 28px;
        font-size: 20px;
        margin-bottom: 40px;
    }
    .index-box .btn-box{
        width: 100%;
    }
    .result-box{
        width: 100%;
        height: auto;
        padding-top: 40px;
    }
    .result-box .top-ico{
        width: 840px;
        height: 40px;
        color: #07cc00;
        font-size: 24px;
        text-align: center;
        line-height: 40px;
        margin-left: 100px;
        margin-bottom: 20px;
    }
    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    .result-box .item{
        width: 100%;
        height: auto;
        padding-bottom: 20px;
    }
    .result-box .item .l{
        display: inline-block;
        width: 100px;
        height: 40px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .m{
        display: inline-block;
        width: 720px;
        height: 40px;
        vertical-align: top;
    }
    .result-box .item .r{
        display: inline-block;
        width: 98px;
        height: 40px;
        margin-left: 22px;
        vertical-align: top;
    }
    .result-box .item .lab{
        display: inline-block;
        width: 100px;
        color: #606266;
        font-size: 14px;
        text-align: right;
        line-height: 40px;
        padding-right: 12px;
        vertical-align: top;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .result-box .item .qrCode{
        display: inline-block;
        width: 200px;
        height: 200px;
        vertical-align: top;
    }
    .result-box .item .dl-btn{
        display: inline-block;
        width: 112px;
        height: 120px;
        margin-left: 40px;
        padding-top: 80px;
        vertical-align: top;
    }

    .clear{clear: both;}

    .about-box{margin-top: 50px;}
    .about-box .index-title2{padding: 10px 0px;font-size: 18px;color:red;}
    .about-box .about-s{width:220px;margin-right:10px;float:left;background:#f4f7f369;height:90px;margin-top: 10px;}
    .about-box .about-s .about-s-main{padding:15px;}
    .about-box .title2{font-weight: bold;padding:20px 0;}
    .about-box .about-s b{font-size:14px;font-weight: bold;color:#2d5dee;}
    .about-box i{font-size:20px;   }
    .about-box p{font-size: 14px;}

    .chioce-huoma-list{
      display: inline-block;
    }
    .chioce-huoma-mode {
      width: 80%;
      margin: 0 auto;
      margin-top: 15px;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .chioce-huoma-list input {
      width: 0;
      height: 0;
      opacity: 0;
    }
    .chioce-huoma-list input:checked + i {
      display: block;
      width: 16px;
      height: 16px;
      background: url(//static.3w.cn/static/home-3wcn/images/swich-mode-checked.png);
      margin-right: 3px;
      background-size: 16px 16px;
    }
    .chioce-huoma-list i {
      display: block;
      width: 16px;
      height: 16px;
      background: url(//static.3w.cn/static/home-3wcn/images/swich-mode-unchecked.png);
      margin-right: 3px;
      background-size: 16px 16px;
    }
    .ml-30 {
      margin-left: 30px;
    }
    .cursor-pointer {
      cursor: pointer;
    }
    .chioce-huoma-list input {
      width: 0;
      height: 0;
      opacity: 0;
    }
    .chioce-huoma-list i {
      display: block;
      width: 16px;
      height: 16px;
      background: url(//static.3w.cn/static/home-3wcn/images/swich-mode-unchecked.png);
      margin-right: 3px;
      background-size: 16px 16px;
    }
    .tips-groug-wen {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-left: 5px;
      cursor: pointer;
      position: relative;
    }
    .tips-groug-wen img {
      display: block;
      width: 14px;
      height: 14px;
    }
    img {
      border: none;
      vertical-align: middle;
    }
    .tips-groug-wen-info {
      position: absolute;
      top: 20px;
      left: 0;
      padding: 10px;
      background: #F5F7F6;
      width: 250px;
      border-radius: 5px;
      z-index: 11;
      display: none;
    }
    .tips-groug-wen-info p {
      font-size: 14px;
      color: #4d4d4d;
    }
    .tips-groug-wen-info span {
      font-size: 12px;
      color: #919191;
    }
    .introduce-card {
      width: 645px;
      padding: 26px 29px 23px 26px;
      border-radius: 1px;
      border: 1px dashed rgba(206, 206, 206, 1);
      margin: 0 auto;
      margin-top: 146px;
      margin-bottom: 63px;
    }
    .position-relative {
      position: relative;
    }
    .icon-support {
      width: 120px;
      left: 50%;
      top: -120px;
      transform: translateX(-50%);
    }
    .position-absolute {
      position: absolute;
    }
    .icon-support p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(181, 181, 181, 1);
      line-height: 17px;
      text-align: center;
      margin-bottom: 10px;
    }
    .introduce-card p {
      font-size: 14px;
      font-weight: 600;
      color: #4D4D4D;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .icon-support img {
      width: 30px;
      height: 30px;
    }

    .introduce-card p {
      font-size: 14px;
      font-weight: 600;
      color: #4D4D4D;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .introduce-card span:nth-of-type(1) {
      margin-bottom: 15px;
    }
    .introduce-card span {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      color: #919191;
      line-height: 20px;
    }
    .introduce-card p {
      font-size: 14px;
      font-weight: 600;
      color: #4D4D4D;
      line-height: 20px;
      margin-bottom: 8px;
    }
    .introduce-card span {
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      color: #919191;
      line-height: 20px;
    }
</style>
